import { render } from "./GooglePlayCode.vue?vue&type=template&id=bfa8a8ce"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__